import { z } from 'zod';
import { id, constrainedStrings } from './common';

export const iconSourceSchema = z.enum([
  'lucide',          // Lucide React icons
  'custom',          // Custom isometric SVG icons
  'cloud-provider',  // AWS/Azure/GCP/Kubernetes icons
  'reshot',          // Legacy: keep for backward compatibility
  'user-upload'      // User-uploaded custom icons (future)
]);

export const iconSchema = z.object({
  id,
  name: constrainedStrings.name,
  url: z.string(),
  collection: constrainedStrings.name.optional(),
  isIsometric: z.boolean().optional(),
  source: iconSourceSchema.optional(),
});

export const iconsSchema = z.array(iconSchema);
